document.addEventListener('DOMContentLoaded', () => {
  let observer = null;

  const setJudgeMeArrowLabels = () => {
    const arrows = document.querySelectorAll('.jdgm-arrow');

    if (arrows.length < 2) return false;

    arrows[0].setAttribute('aria-label', 'Go to previous review');
    arrows[1].setAttribute('aria-label', 'Go to next review');

    return true;
  };

  if (setJudgeMeArrowLabels()) return;

  observer = new MutationObserver(() => {
    if (!setJudgeMeArrowLabels()) return;

    observer.disconnect();
    observer = null;
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});